export const REPORT_TYPE = {
	CUSTOMER: "total-customer",
	MERCHANT: "total-merchant",
	REVENUE: "total-revenue",
	SOLDCAR: "total-sold-car",
	CAR: "total-car",
	APPOINTMENT: "total-booking",
};

export const MAX_DATE_FILTER = 30;
export const MAX_MONTH_FILTER = 12;
export const MAX_QUARTER_FILTER = 12;

export const CHART_FILTERS = [
	{
		label: "Date",
		value: "date",
	},
	{
		label: "Month",
		value: "month",
	},
	{
		label: "Quarter",
		value: "quarter",
	},
	{
		label: "Year",
		value: "year",
	},
];
